import { Link } from 'react-router-dom';
import GateHausLogo from '../components/GateHausLogo';

const RegisterPage = () => {
  const registrationUrl = 'https://api.gate.haus/v2/auth/register-ui.php';

  return (
    <div className="full-centre">
      <div className="card" style={{ width: '420px', textAlign: 'center' }}>
        <GateHausLogo stacked size={44} />
        <h2>Create your identity</h2>
        <p style={{ color: 'var(--gray)' }}>Sign up for Gate.haus to access the platform.</p>
        <a className="primary-button" href={registrationUrl}>
          Create account
        </a>
        <p style={{ marginTop: '1rem', fontSize: '0.9rem' }}>
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
